import { createClient } from '@supabase/supabase-js'

// Browser-side Supabase client for Auth flows (sign-in / sign-out / session).
// Uses the public anon key — that's the intended pattern for client-side
// Supabase usage; the secret key never leaves the server.
//
// Vite exposes env vars via import.meta.env, but only those prefixed with
// VITE_ get bundled. Both VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are
// safe to ship to the browser.

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

if (!url || !anonKey) {
  throw new Error(
    'Supabase env vars missing. Set VITE_SUPABASE_URL and '
    + 'VITE_SUPABASE_ANON_KEY in the build environment.',
  )
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
})
